const getJobRolePreview = state => {
  return state.jobRolesPreview.getJobRoleData
}

const getCandidateListList = state => {
  return state.jobRolesPreview.getCandidateListData
}

const getCandidateMetrics = state => {
  return state.jobRolesPreview.metricsData
}

const selector = {
  getJobRolePreview,
  getCandidateListList,
  getCandidateMetrics,
}

export default selector
